<template>
    <div class="flex justify-center my-6">
        <div class="flex flex-col w-full text-center p-8 text-gray-800 bg-white shadow-lg pin-r pin-y md:w-4/6">
            <h1 class="text-xl font-bold text-cavilam-primary">{{ __('confirmation_paiement') }}</h1>

            <p v-if="hasProduit14Juillet"
               class="my-4 font-bold"
               v-html="__('exception_14_juillet')"></p>

            <p v-else class="my-4" v-html="__('text_confirmation_paiement')"></p>

            <template v-if="$page.props.auth.user || (this.client && this.client.utilisateur_id)">
                <p class="my-2">
                    <span v-html="__('retrouvez_vos_commandes_passees_dans_votre_historique')"></span>
                    <inertia-link class="font-semibold" :href="route('utilisateur.commandes')">{{ __('voir_mes_commandes') }}</inertia-link>
                </p>
            </template>
            <template v-else>
                <p v-html="__('rattachez_votre_commande_a_un_compte', [{'key': 'transactionId', 'value': transactionId}])"></p>
                <div class="flex">
                    <button class="my-4 inline-block px-6 py-2 text-xs font-medium
                            leading-4 text-center text-white uppercase max-w-xs
                            mx-auto transition bg-cavilam-primary rounded shadow ripple
                            hover:shadow-lg hover:opacity-95 focus:outline-none"
                            @click="showCompteExistant">
                        {{ __('rattachez_a_compte_existant') }}
                    </button>
                    <button class="my-4 inline-block px-6 py-2 text-xs font-medium
                            leading-4 text-center text-white uppercase max-w-xs
                            mx-auto transition bg-cavilam-primary rounded shadow ripple
                            hover:shadow-lg hover:opacity-95 focus:outline-none"
                                  @click="showCreerCompte">
                        {{ __('creez_un_compte') }}
                    </button>
                </div>
                <template v-if="showForm === 1">
                    <form class="w-3/6 m-auto" @submit.prevent="submit">
                        <div class="mt-4">
                            <breeze-label for="email" :value="__('Email')" />
                            <breeze-input id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autocomplete="email" />
                        </div>

                        <div class="mt-4">
                            <breeze-label for="password" :value="__('Password')" />
                            <breeze-input id="password" type="password" class="mt-1 block w-full" v-model="form.password" required autocomplete="current-password" />
                        </div>

                        <div class="flex items-center justify-center mt-4">
                            <inertia-link v-if="canResetPassword" :href="route('password.request')" class="underline text-sm text-gray-600 hover:text-gray-900">
                                {{ __('mot_de_passe_oublie') }}
                            </inertia-link>

                            <breeze-button class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                {{ __('log_in') }}
                            </breeze-button>
                        </div>
                    </form>
                </template>
                <template v-else-if="showForm === 2">
                    <form class="w-3/6 m-auto" @submit.prevent="submit">
                        <div class="mt-4">
                            <breeze-label for="email" :value="__('Email')" />
                            <breeze-input id="email" type="email" class="mt-1 block w-full" v-model="form.email" :readonly="form.email" required autocomplete="username" />
                            <p class="text-red-500 text-xs" :class="{'invisible':!form.errors.email}">{{ __(form.errors.email) }}</p>
                        </div>

                        <div class="mt-4">
                            <breeze-label for="password" :value="__('Password')" />
                            <breeze-input id="password" type="password" class="mt-1 block w-full" v-model="form.password" required autocomplete="new-password" />
                            <p class="text-red-500 text-xs" :class="{'invisible':!form.errors.password}">{{ __(form.errors.password) }}</p>
                        </div>

                        <div class="mt-4">
                            <breeze-label for="password_confirmation" :value="__('password_confirm')" />
                            <breeze-input id="password_confirmation" type="password" class="mt-1 block w-full" v-model="form.password_confirmation" required autocomplete="new-password" />
                            <p class="text-red-500 text-xs" :class="{'invisible':!form.errors.password_confirmation}">{{ __(form.errors.password_confirmation) }}</p>
                        </div>

                        <div class="flex items-center justify-center mt-4">
                            <breeze-button class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                {{ __('valider') }}
                            </breeze-button>
                        </div>
                    </form>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
import App from '@/Layouts/App'
import BreezeButton from '@/Components/Button'
import BreezeInput from '@/Components/Input'
import BreezeCheckbox from '@/Components/Checkbox'
import BreezeLabel from '@/Components/Label'
import BreezeValidationErrors from '@/Components/ValidationErrors'

export default {
    layout: App,
    name: "Reussi",
    components: {
        BreezeButton,
        BreezeInput,
        BreezeCheckbox,
        BreezeLabel,
        BreezeValidationErrors
    },
    data: function () {
       return {
           showForm: null,
           form: this.$inertia.form({
               email: '',
               password: '',
               password_confirmation: '',
               terms: true,
               rattachementClient: null
           })
       }
    },
    props: {
        transactionId: String,
        client: Object,
        canResetPassword: Boolean,
        hasProduit14Juillet: Boolean,
        panier: Object,
    },
    created:function() {
        this.form.email = this.client.email;
        this.form.rattachementClient = this.client.id;

        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
            event: "purchase",
            ecommerce: {
                // transaction_id: this.commande,
                // Sum of (price * quantity) for all items.
                value: this.montantSousTotal(),
                // shipping: 5.99,
                currency: "EUR",
                items: this.TM_get_items(),
            }
        });
    },
    methods: {
        submit() {
            if(this.showForm === 1) {
                this.form
                    .transform(data => ({
                        ... data,
                        remember: ''
                    }))
                    .post(this.route('login'), {
                        onFinish: () => this.form.reset('password'),
                    });
            } else if(this.showForm === 2) {
                this.form.post(this.route('register'), {
                    onFinish: () => this.form.reset('password', 'password_confirmation'),
                })
            }
        },
        showCompteExistant() {
            this.form.email = this.client.email;
            this.form.rattachementClient = this.client.id;
            this.showForm = 1;
        },
        showCreerCompte() {
            this.form.email = this.client.email;
            this.form.rattachementClient = this.client.id;
            this.showForm = 2;
        },

        // #region Google Analytics (Tag Manager)
        TM_get_items() {
            let items = [];
            for(let itemId in this.panier) {
                let item = this.panier[itemId];
                let tarif = item.attributes.produit.tarifs.find(tarif => {
                    return tarif.annee == (new Date()).getFullYear();
                });
                if (!tarif) tarif = item.attributes.produit.tarifs[0];

                items.push({
                    item_id: item.attributes.produit.id,
                    item_name: this.__(item.attributes.produit.slug),
                    item_category: this.__(item.attributes.categorie.slug),
                    item_list_id: item.attributes.categorie.id,
                    item_list_name: this.__(item.attributes.categorie.slug),
                    price: tarif.montant,
                    quantity: item.quantity,
                });
            }
            return items;
        },
        // #endregion Google Analytics (Tag Manager)

        montantItem: function (id) {
            let prix = parseFloat(0);
            prix += parseFloat(this.panier[id].price);
            prix += parseFloat(this.montantOptions(id));
            return parseFloat(prix).toFixed(2);
        },
        montantOptions(id) {
            let prix = parseFloat(0);
            for(let etape in this.panier[id].attributes.etapes) {
                let elemEtape = this.panier[id].attributes.etapes[etape];

                // Les frais de transferts seront à régler sur place
                if (elemEtape.nom === 'transfert') continue;

                for(let option in elemEtape.options) {

                    if(!elemEtape.options[option] || !elemEtape.options[option].valeur || typeof elemEtape.options[option].valeur !== 'object' || !elemEtape.options[option].valeur.montant)
                        continue;

                    if(elemEtape.options[option].valeur.type === 'number') {
                        prix += parseFloat(elemEtape.options[option].valeur.montant) * parseFloat(elemEtape.options[option].valeur.value);
                    } else {
                        prix += parseFloat(elemEtape.options[option].valeur.montant);
                    }

                }
            }
            return parseFloat(prix).toFixed(2);
        },
        montantSousTotal() {
            let prix = parseFloat(0);
            for(let itemId in this.panier) {
                prix += parseFloat(this.montantItem(itemId));
            }
            return parseFloat(prix).toFixed(2);
        },
    }
}
</script>

<style scoped>

</style>
